/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import React, { Component } from 'react';
import './styles/css/login.css';
import { Button, Segment, Form, Input, Header, Checkbox, Icon } from 'semantic-ui-react';
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Popup from './forgot-login';
import API from '../utility/API';
import {getWlBackGroundColor,getWhiteLabelCustomerName} from "./../util.js"


class ForgotPassword extends Component {
  constructor() {
    super();
    this.state = {
        checkEmail: false,
        emailVerificationPage: false,
    }
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value }, console.log(this.state))

  handleSubmit = (evt) => {
    evt.preventDefault();
    const { email } = this.state
    API.forgotPassword(
      this.state.email
    ).then(response => {
      return response.json()
    }).then(responseData => {
      if (responseData.eventMessage.header.code === 301) {
        document.getElementById('loginError').innerHTML = "<br /><center> Email is not registered. </center>"
        this.setState({ error: true })
      } else if (responseData.eventMessage.header.code === 200) {
          this.setState ({ checkEmail: true })
      } else if (responseData.eventMessage.header.code === 400) {
          this.setState ({ emailVerificationPage: true })
      }
    }).catch(err => console.log('ERROR:', err))
  }

  render() {
    const { emailVerificationPage, email } = this.state;
    if(emailVerificationPage) return <Redirect to={{ pathname: '/email-verification', state: { email } }} />

    console.log(window._env_.REACT_APP_LOGIN_URL_CUSTOMER)

    if (this.state.toNextPage === true) {
      document.location = window._env_.REACT_APP_LOGIN_URL_CUSTOMER;
    }

    // else if (this.state.toNextPage === true && window.location.href === 'http://localhost:3000/') {
    //   document.location = 'https://customer-dev.klearexpress.com';
    // } else if (this.state.toNextPage === true && window.location.href === 'https://cob-staging.klearexpress.com/') {
    //   document.location = 'https://customer-staging.klearexpress.com';
    // } else if (this.state.toNextPage === true && window.location.href === 'https://cob.klearexpress.com/') {
    //   document.location = 'https://customer.klearexpress.com';
    // }

    return (
      // <div className="left-div">
      <Segment className="login-container" >

      {this.state.checkEmail === true ?
        <center>
          <Icon className='mailSent' name='mail outline' />
          <p>Please check your email and follow the instructions to reset your password.</p>
        </center>
      :

        <Form id='forgot-password' onSubmit={this.handleSubmit}>
          <p className="login-header">Forgot Password</p>
          <br />
          <Form.Field>
            <label>Please enter your email that you used to signup with us.</label>
            <Input placeholder='Your email address'
              fluid
              name="email"
              type="email"
              value={email}
              className="login-input"
              onChange={this.handleChange}
            />
          </Form.Field>
          <br />

          {/* <Link to='#'> */}
            <Button
              onClick={this.handleSubmit}
              type='submit'
              className="loginButton"
              color="twitter"
              size='small'
              disabled={!this.state.email}
              style={getWhiteLabelCustomerName().length > 0 ? {backgroundColor: getWlBackGroundColor()} : null}
            >SUBMIT</Button>
            <div id='loginError'></div>
          {/* </Link> */}
          <br />
        </Form>
        }
          <br />
          <br />
          <br />

          <center>
            {/* <Link to='#' className="forgotLogin" onClick={this.togglePopup.bind(this)}>Forgot Username / Password?</Link>
            <br /> <br /> */}
            <Link to='/' className="forgotLogin" > Back to Login</Link>
          </center>
 
      </Segment>
      // </div>
    );
  }
}

export default ForgotPassword;
